import { Resolution } from 'common';

export const getResolution = (): Resolution => ({ width: window.screen.width, height: window.screen.height });
